module.exports = __webpack_public_path__ + "static/img/4yuanshuju.aa767af7.jpg";